Object.defineProperty(exports, "__esModule", { value: true });
var NotificationsActionTypes;
(function (NotificationsActionTypes) {
    NotificationsActionTypes["TRIGGER_NOTIFICATION"] = "@@edikit/notifications/TRIGGER_NOTIFICATION";
    NotificationsActionTypes["CLOSE_NOTIFICATION"] = "@@edikit/notifications/CLOSE_NOTIFICATION";
})(NotificationsActionTypes = exports.NotificationsActionTypes || (exports.NotificationsActionTypes = {}));
